var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homeItems" },
    [
      _c("c-header-return", { attrs: { title: "自建箱子" } }),
      _c("div", { staticClass: "homeContainerItems" }, [
        _c(
          "div",
          { staticClass: "homeContainerItem-content" },
          [
            _vm.$screen.mobile
              ? _c(
                  "div",
                  {
                    staticClass:
                      "homeContainerItem-content-queryItem-all flex flex-center-1",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "homeContainerItem-content-queryItem flex flex-ver",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "category-items flex flex-ver",
                            class: { active: _vm.active_cate == "all" },
                            on: {
                              click: function ($event) {
                                return _vm.onClickCaseItmHandle("all")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "category-items-icon el-icon-menu",
                            }),
                            _c("p", [_vm._v("所有")]),
                          ]
                        ),
                        _vm._l(_vm.boxList.category, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "category-items flex flex-ver",
                              class: { active: _vm.active_cate == item },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickCaseItmHandle(item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "category-items-icon el-icon-s-cooperation",
                              }),
                              _c("p", [_vm._v(_vm._s(item))]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "create-box-btn flex flex-center-1",
                        on: {
                          click: function ($event) {
                            return _vm.pathGo({ name: "boxCreate" })
                          },
                        },
                      },
                      [_vm._v(" 创建箱子 ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "icon flex flex-center-1",
                        class: { "icon-active": _vm.isShowShaixuan },
                        on: { click: _vm.onShaixuanHandle },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/icons/icon1_active.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" 筛选 "),
                      ]
                    ),
                    _c("div", { staticClass: "shadow" }),
                  ]
                )
              : _vm._e(),
            !_vm.$screen.mobile
              ? _c(
                  "div",
                  {
                    staticClass:
                      "homeContainerItem-content-queryItem flex flex-ver",
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "categoryItems",
                        staticClass:
                          "homeContainerItem-content-queryItem-item flex flex-ver",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "category-items flex flex-ver",
                            class: { active: _vm.active_cate == "all" },
                            on: {
                              click: function ($event) {
                                return _vm.onClickCaseItmHandle("all")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "category-items-icon el-icon-menu",
                            }),
                            _c("p", [_vm._v("所有")]),
                          ]
                        ),
                        _vm._l(_vm.category, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "category-items flex flex-ver",
                              class: { active: _vm.active_cate == item },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickCaseItmHandle(item)
                                },
                              },
                            },
                            [_c("p", [_vm._v(_vm._s(item.label))])]
                          )
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "category-items flex flex-ver",
                            class: { active: true },
                            on: {
                              click: function ($event) {
                                return _vm.pathGo({ name: "boxCreate" })
                              },
                            },
                          },
                          [_c("p", [_vm._v("创建箱子")])]
                        ),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "homeContainerItem-content-queryItem-1",
                class: {
                  mobileshaixuan: _vm.$screen.mobile && _vm.isShowShaixuan,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "homeContainerItem-content-query-item" },
                  [
                    _c("p", { staticClass: "queryItem-title" }, [
                      _vm._v("价格范围"),
                    ]),
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            _vm.isShowShaixuan = false
                          },
                        },
                        model: {
                          value: _vm.price_range_value,
                          callback: function ($$v) {
                            _vm.price_range_value = $$v
                          },
                          expression: "price_range_value",
                        },
                      },
                      _vm._l(_vm.price_range_list, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "homeContainerItem-content-query-item" },
                  [
                    _c("p", { staticClass: "queryItem-title" }, [
                      _vm._v("排序范围"),
                    ]),
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            _vm.isShowShaixuan = false
                          },
                        },
                        model: {
                          value: _vm.price_sort_index,
                          callback: function ($$v) {
                            _vm.price_sort_index = $$v
                          },
                          expression: "price_sort_index",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "默认", value: "all" },
                        }),
                        _vm._l(_vm.price_sort_list, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "homeContainerItem-content-query-item" },
                  [
                    _c("p", { staticClass: "queryItem-title" }, [
                      _vm._v("风险等级"),
                    ]),
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            _vm.isShowShaixuan = false
                          },
                        },
                        model: {
                          value: _vm.risk_sort_index,
                          callback: function ($$v) {
                            _vm.risk_sort_index = $$v
                          },
                          expression: "risk_sort_index",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "默认", value: "all" },
                        }),
                        _vm._l(_vm.risk_sort_list, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm.active_cate != "副本箱列表"
              ? _c(
                  "div",
                  { staticClass: "homeContainerItem-content-listItem" },
                  _vm._l(
                    _vm.cateCaseList(_vm.active_cate),
                    function (caseItem, caseIndex) {
                      return _c("c-case-item", {
                        key: caseIndex,
                        attrs: {
                          caseItem: caseItem,
                          background:
                            "linear-gradient(180deg, #362d1b 0%, #131008 100%)",
                          "show-creator-name": true,
                        },
                        on: {
                          onCaseDetailHadle: function ($event) {
                            return _vm.pathGo({
                              name: "case",
                              params: caseItem,
                              id: caseItem.caseId,
                              query: { userCase: 1 },
                            })
                          },
                        },
                      })
                    }
                  ),
                  1
                )
              : _vm._e(),
            _vm.active_cate == "副本箱列表"
              ? _c("c-gameInstanceBox")
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "450rem",
            closable: false,
          },
          model: {
            value: _vm.multiplePeople_cases_rules_show,
            callback: function ($$v) {
              _vm.multiplePeople_cases_rules_show = $$v
            },
            expression: "multiplePeople_cases_rules_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "多人开箱说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.multiplePeople_cases_rules_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 1. 合开状态达标才会进行开箱。"),
                  _c("br"),
                  _vm._v(" 2. 开箱后立即进入开箱饰品抽选环节。"),
                  _c("br"),
                  _vm._v(" 3. 有份额的玩家皆自动参加抽选。"),
                  _c("br"),
                  _vm._v(" 4. 玩家的抽选概率（%）等于份额占比（%）。 "),
                  _c("br"),
                  _vm._v(" 5. 当箱子饰品开出后，仅抽选1位玩家获得所有饰品。"),
                  _c("br"),
                  _vm._v(" 6. 未抽中任何饰品的玩家自动获得0.01存入余额。"),
                  _c("br"),
                  _vm._v(
                    " 7. 同开箱局一玩家最高份额占比为 " +
                      _vm._s(
                        Number(
                          _vm.mpcCaseSettings.mpCaseMaximumPercent * 100
                        ).toFixed(2)
                      ) +
                      " % 。"
                  ),
                  _c("br"),
                  _vm._v(" 8. 创建多人开箱1局最多5个盲盒。"),
                  _c("br"),
                  _vm._v(
                    " 9. 创建开箱局总价格最低为 " +
                      _vm._s(parseInt(_vm.mpcCaseSettings.mpCaseMinimumPrice)) +
                      " 元。 "
                  ),
                  _c("br"),
                  _vm._v(
                    " 10. 1份额为开箱局总价格的 " +
                      _vm._s(
                        Number(
                          _vm.mpcCaseSettings.mpCaseMinimumPercent * 100
                        ).toFixed(2)
                      ) +
                      " % 。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 11. 当倒数结束合开未达标，则该局自动关闭，并退还份额。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 12. 合开期间若有下架盲盒，则该局自动关闭，并退还份额。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("c-new-multiple-people-case", {
        ref: "cNewMultiplepeopleCase",
        attrs: {
          mpcCaseSettings: _vm.mpcCaseSettings,
          battleCaseList: _vm.battleCaseList,
          caseData: _vm.caseData,
        },
        on: { createNewCase: _vm.createNewMultiplepeopleCase },
        model: {
          value: _vm.new_multiplePeople_cases_show,
          callback: function ($$v) {
            _vm.new_multiplePeople_cases_show = $$v
          },
          expression: "new_multiplePeople_cases_show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }